import * as React from 'react';
import {RegistrationSuccessScreenType} from '@practicegenius/register-account/src/screens/RegistrationSuccess';
import {IMT, strongify} from '@practicegenius/pg-util/src/StringUtils';
import lang from '@practicegenius/register-account/src/lang';
import {ProgressScreen} from '../../../components/screens/BaseScreen';
import {CenteredWrapper} from '../../../components/screens/layout';
import success from '../../../components/SvgImage/svgs-raw/registrationSuccess.svg';

const pageLang = lang.registrationSuccess;

export const RegistrationSuccess: RegistrationSuccessScreenType = ({
  progress,
  firstname = '',
  actionButtons,
  username,
  email,
}) => {
  return (
    <ProgressScreen
      helmetTitle={pageLang.pageTitle}
      progress={progress}
      headerTitle={pageLang.headerTitle}
      title={pageLang.title}
      instructions={
        <span
          dangerouslySetInnerHTML={{
            __html: IMT(lang.registrationSuccess.instructions.base, {
              firstName: firstname,
              username: username || email,
              bold: strongify,
              primaryColor() {
                return (text: string, render: (txt: string) => string) =>
                  `<span style="color: #222222">${render(
                    text || 'placeholder'
                  )}</span>`;
              },
            }),
          }}
        />
      }
      actionButtons={[actionButtons.primary]}
      cancelProps={{href: '/'}}
    >
      <CenteredWrapper>
        <img src={success} style={{height: 165}} alt="Success" />
      </CenteredWrapper>
    </ProgressScreen>
  );
};
